import parse, { HTMLReactParserOptions } from "html-react-parser";

/**
 * Safely parses an HTML string into React elements.
 * @param html - The HTML string to parse
 * @param options - Optional parser options for element transformation
 * @returns Parsed React elements
 */
export const parseHtml = (html: string, options?: HTMLReactParserOptions) => {
  if (!html) return null;
  return parse(html, options);
};
